/* eslint-disable */
export function getPrivateKey(account, password) {
  if (account.privatekey) {
    const mnemonic_recover = bytetrade_js.key.decrypt_mnemonic(
      account.mnemoniccliper,
      account.userid,
      password,
    );
    return bytetrade_js.PrivateKey.fromHex(mnemonic_recover);
  }
  const mnemonic_recover = bytetrade_js.key.decrypt_mnemonic(
    account.mnemoniccliper,
    account.userid,
    password,
  );
  return bytetrade_js.PrivateKey.fromSeed(
    bytetrade_js.key.mnemonicToSeedHex(mnemonic_recover),
  );
}
export function changePromptStyle(type) {
  setTimeout(() => {
    try {
      document
        .querySelector('.el-message-box__content input')
        .setAttribute('type', type);
      // document.querySelector('body').setAttribute("style",'')
    } catch (error) {
      console.error(error);
    }
  }, 100);
}



// WEBPACK FOOTER //
// ./src/service/index.js